import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	referenceDepthLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inboundReferencesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	helpText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'1': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'2': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'3': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'4': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'5': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	referenceDepthLabel: {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.reference-depth-label',
		defaultMessage: 'Reference depth',
		description: 'Label help text for the CMDB object graph configuration panel dropdown input',
	},
	inboundReferencesLabel: {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.inbound-references-label',
		defaultMessage: 'Inbound references',
		description:
			'Label help text for the CMDB object graph configuration panel number picker input',
	},
	helpText: {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.help-text',
		defaultMessage:
			'The maximum number of inbound references from the same object type, before grouping them as a single node.',
		description: 'Label help text for the CMDB object graph reference depth configuration ',
	},
	'1': {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.1',
		defaultMessage: '1',
		description: 'The number 1 shown in number picker dropdown list',
	},
	'2': {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.2',
		defaultMessage: '2',
		description: 'The number 2 shown in number picker dropdown list',
	},
	'3': {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.3',
		defaultMessage: '3',
		description: 'The number 3 shown in number picker dropdown list',
	},
	'4': {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.4',
		defaultMessage: '4',
		description: 'The number 4 shown in number picker dropdown list',
	},
	'5': {
		id: 'servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.5',
		defaultMessage: '5',
		description: 'The number 5 shown in number picker dropdown list',
	},
});
export default messages;
